/**
 * Base data for Limited Time Offer promo
 *
 * @type {{
 *  heading: string,
 *  body: string,
 *  image: Object,
 * }}
 */
export const LTO_PROMO_CONTENT = (limitedTimeOfferDate = '') => {
  const ltoOfferDate = limitedTimeOfferDate && ` by ${limitedTimeOfferDate}`;

  return {
    heading: 'A $130 value for you!',
    body: `Get <strong>$30 in card rewards</strong><sup>§</sup> when you’re approved for the REI Co-op<sup>®</sup> Mastercard<sup>®</sup>${ltoOfferDate}. Plus, you can <strong>earn a $100 REI gift card</strong> after your first non-REI purchase within 60 days from account opening.* Terms apply.`,
    image: {
      src: 'https://www.rei.com/dam/limited-time-offer-credit-card',
      alt: 'Limited-Time Offer A $130 in value for you!',
    },
    link: {
      target: '/membership/mastercard/preapproval',
      text: 'Learn more',
    },
  };
};
